import { Vec2 } from '../../math/vec2.js';
import { Seat } from './seat.js';
import { SeatingElement } from './seating-element.js';

export abstract class SeatGroup extends SeatingElement {
  public readonly seats: Seat[];

  constructor(
      uniqueId: number,
      enabled: boolean,
      position: Vec2,
      rotation: number,
      parent: WeakRef<SeatingElement> | null,
      seats: Seat[],
  ) {
    super(uniqueId, enabled, position, rotation, parent);
    this.seats = seats;
  }
}
